import { REHYDRATE } from 'redux-persist';
import { types } from 'constants/Auth';

const initialState = {
   auth: {
      login: {
         loading: false,
         error: '',
         user: {},
      },
      forgot_password: {
         loading: false,
         error: '',
      },
      update_forgot_password: {
         loading: false,
         error: '',
      },
      check_forgot_password: {
         loading: false,
         error: '',
         success: false,
      },
      forgot_pin: {
         loading: false,
         error: '',
      },
      update_forgot_pin: {
         loading: false,
         error: '',
      },
      check_forgot_pin: {
         loading: false,
         error: '',
         success: false,
      },
      logout: {
         loading: '',
         error: '',
      },
   },
};

const auth = (state = initialState.auth, action) => {
   switch (action.type) {
      case REHYDRATE: {
         const incoming = action.payload?.auth;
         if (!incoming) return state;
         // jangan pulihkan flag loading transient dari localStorage
         return {
            ...state,
            ...incoming,
            login: { ...incoming.login, loading: false },
            forgot_password: { ...incoming.forgot_password, loading: false },
            update_forgot_password: {
               ...incoming.update_forgot_password,
               loading: false,
            },
            check_forgot_password: {
               ...incoming.check_forgot_password,
               loading: false,
            },
            forgot_pin: { ...incoming.forgot_pin, loading: false },
            update_forgot_pin: {
               ...incoming.update_forgot_pin,
               loading: false,
            },
            check_forgot_pin: { ...incoming.check_forgot_pin, loading: false },
            logout: { ...incoming.logout, loading: false },
         };
      }
      case types.AUTH_LOADING:
         return {
            ...state,
            login: {
               ...state.login,
               loading: true,
            },
         };
      case types.AUTH_SUCCESS:
         return {
            ...state,
            login: {
               ...state.login,
               user: action.data,
               loading: false,
               error: '',
            },
         };
      case types.AUTH_FAILED:
         return {
            ...state,
            login: {
               ...state.login,
               user: {},
               loading: false,
               error: action.message,
            },
         };

      case types.FORGOT_PASSWORD_LOADING:
         return {
            ...state,
            forgot_password: {
               ...state.forgot_password,
               loading: true,
            },
         };
      case types.FORGOT_PASSWORD_SUCCESS:
         return {
            ...state,
            forgot_password: {
               ...state.forgot_password,
               loading: false,
               error: '',
            },
         };
      case types.FORGOT_PASSWORD_PASSWORD:
         return {
            ...state,
            forgot_password: {
               ...state.forgot_password,
               loading: false,
               error: action.message,
            },
         };

      case types.UPDATE_FORGOT_PASSWORD_LOADING:
         return {
            ...state,
            update_forgot_password: {
               ...state.update_forgot_password,
               loading: true,
            },
         };
      case types.UPDATE_FORGOT_PASSWORD_SUCCESS:
         return {
            ...state,
            update_forgot_password: {
               ...state.update_forgot_password,
               loading: false,
               error: '',
            },
         };
      case types.UPDATE_FORGOT_PASSWORD_FAILED:
         return {
            ...state,
            update_forgot_password: {
               ...state.update_forgot_password,
               loading: false,
               error: action.message,
            },
         };

      case types.CHECK_FORGOT_PASSWORD_LOADING:
         return {
            ...state,
            check_forgot_password: {
               ...state.check_forgot_password,
               loading: true,
               success: false,
               error: '',
            },
         };
      case types.CHECK_FORGOT_PASSWORD_SUCCESS:
         return {
            ...state,
            check_forgot_password: {
               ...state.check_forgot_password,
               loading: false,
               success: true,
               error: '',
            },
         };
      case types.CHECK_FORGOT_PASSWORD_FAILED:
         return {
            ...state,
            check_forgot_password: {
               ...state.check_forgot_password,
               loading: false,
               error: action.message,
            },
         };
      case types.FORGOT_PIN_LOADING:
         return {
            ...state,
            forgot_pin: {
               ...state.forgot_pin,
               loading: true,
            },
         };
      case types.FORGOT_PIN_SUCCESS:
         return {
            ...state,
            forgot_pin: {
               ...state.forgot_pin,
               loading: false,
               error: '',
            },
         };
      case types.FORGOT_PIN_FAILED:
         return {
            ...state,
            forgot_pin: {
               ...state.forgot_pin,
               loading: false,
               error: action.message,
            },
         };
      case types.UPDATE_FORGOT_PIN_LOADING:
         return {
            ...state,
            update_forgot_pin: {
               ...state.update_forgot_pin,
               loading: true,
            },
         };
      case types.UPDATE_FORGOT_PIN_SUCCESS:
         return {
            ...state,
            update_forgot_pin: {
               ...state.update_forgot_pin,
               loading: false,
               error: '',
            },
         };
      case types.UPDATE_FORGOT_PIN_FAILED:
         return {
            ...state,
            update_forgot_pin: {
               ...state.update_forgot_pin,
               loading: false,
               error: action.message,
            },
         };

      case types.CHECK_FORGOT_PIN_LOADING:
         return {
            ...state,
            check_forgot_pin: {
               ...state.check_forgot_pin,
               loading: true,
               success: false,
               error: '',
            },
         };
      case types.CHECK_FORGOT_PIN_SUCCESS:
         return {
            ...state,
            check_forgot_pin: {
               ...state.check_forgot_pin,
               loading: false,
               success: true,
               error: '',
            },
         };
      case types.CHECK_FORGOT_PIN_FAILED:
         return {
            ...state,
            check_forgot_pin: {
               ...state.check_forgot_pin,
               loading: false,
               error: action.message,
            },
         };
      case types.LOGOUT_LOADING:
         return {
            ...state,
            logout: {
               ...state.logout,
               loading: true,
            },
         };
      case types.LOGOUT_SUCCESS:
         return {
            ...state,
            logout: {
               ...state.logout,
               loading: false,
               error: '',
            },
         };
      case types.LOGOUT_FAILED:
         return {
            ...state,
            logout: {
               ...state.logout,
               loading: false,
               error: action.message,
            },
         };
      default:
         return state;
   }
};

export default auth;
